import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import EmbedVideo from '@/components/EmbedVideo';

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/embed/:videoId',
      name: 'video',
      component: EmbedVideo,
    },
     {
      path: '/canal_embed/:videoId',
      name: 'video',
      component: EmbedVideo,
    },
    {
      path: '/embed/playlist/:playlistId',
      name: 'embedPlaylist',
      component: EmbedVideo,
    }
  ],
});



// WEBPACK FOOTER //
// ./src/router/routesEmbed.js